import * as React from 'react';
import { connect } from 'react-redux';

import BaseSubcampaignPage from './BaseSubcampaignPage';
import CampaignSummaryShort from 'modules/campaigns/components/campaign-summary/campaign-summary-short/CampaignSummaryShort';
import MessengerInfluencer from 'modules/messenger/components/MessengerInfluencer';

import { t } from 'utils/language';

import type { BrandProfile, Campaign, Subcampaign } from 'types';
import type { Dispatch } from 'redux';

type OwnProps = {
  params: {
    id: string,
    subcampaignId: string
  }
};

type StateProps = {
  subcampaign: Subcampaign | undefined | null,
  campaign: Campaign | undefined | null,
  brandProfile: BrandProfile | undefined | null
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // it is added by connect, so we need to keep it here
} & OwnProps & StateProps;

const SubcampaignMessagesPage = (
  {
    subcampaign,
    campaign,
    brandProfile,
    params
  }: Props
): JSX.Element => (
  <BaseSubcampaignPage
    params={params}
    documentTitle={t('messages_page')}
  >
    {
      subcampaign && subcampaign.id && campaign && campaign.id &&
        <React.Fragment>
          <CampaignSummaryShort
            brandProfile={brandProfile}
            campaign={campaign}
            subcampaign={subcampaign}
            profileType="influencer"
          />
          <MessengerInfluencer subcampaignId={Number(params.subcampaignId)} />
        </React.Fragment>
    }
  </BaseSubcampaignPage>
);

const mapStateToProps = ({ subcampaign, campaignBrief, brandProfile }): StateProps => ({
  subcampaign: subcampaign.data,
  campaign: campaignBrief.brief,
  brandProfile: brandProfile.profile
});

export default connect(mapStateToProps)(SubcampaignMessagesPage);
